// Fork from https://github.com/mattdesl/three-orbit-controls/
// Remove zoom, pan, keys. Rework rotate on hover
//@TODO убрать mousemove с документа, нужен ли тач?

module.exports = function( THREE ) {

    /**
     *
     * @param object THREE.Camera
     * @param domElement
     * @constructor
     */
    function OrbitControls( object, domElement ) {

        this.object = object;

        this.domElement = ( domElement !== undefined ) ? domElement : document;

        // Set to false to disable this control
        this.enabled = true;

        // "target" sets the location of focus, where the object orbits around
        this.target = new THREE.Vector3();
        this.target.x = this.object.position.x;
        this.target.y = this.object.position.y;

        // How far you can orbit vertically, upper and lower limits.
        // Range is 0 to Math.PI radians.
        this.minPolarAngle = - Math.PI / 2; // radians
        this.maxPolarAngle = Math.PI / 2; // radians

        // How far you can orbit horizontally, upper and lower limits.
        // If set, must be a sub-interval of the interval [ - Math.PI, Math.PI ].
        this.minAzimuthAngle = - Infinity; // radians
        this.maxAzimuthAngle = Infinity; // radians

        // Set to false to disable rotating
        this.enableRotate = true;
        this.rotateSpeed = 1.0;

        // Applied rotation from 0 (default position) to 1 (position from mouse)
        this.rotateScale = 1;

        // for reset
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.spherical0 = (new THREE.Spherical()).setFromVector3(this.position0);

        //
        // public methods
        //

        this.getPolarAngle = function () {
            return spherical.phi;
        };

        this.getAzimuthalAngle = function () {
            return spherical.theta;
        };

        this.reset = function () {
            scope.target.copy( scope.target0 );
            scope.object.position.copy( scope.position0 );
            scope.object.updateProjectionMatrix();
            scope.dispatchEvent( changeEvent );
            scope.object.lookAt( scope.target );
            state = STATE.NONE;
        };

        // this method is exposed, but perhaps it would be better if we can make it private...
        this.update = function() {

            // so camera.up is the orbit axis
            let quat = new THREE.Quaternion().setFromUnitVectors( object.up, new THREE.Vector3( 0, 1, 0 ) );
            let quatInverse = quat.clone().inverse();

            let lastPosition = new THREE.Vector3();
            let lastQuaternion = new THREE.Quaternion();

            return function update () {
                spherical = scope.spherical0.clone();
                // restrict theta to be between desired limits
                spherical.theta += Math.max( scope.minAzimuthAngle, Math.min( scope.maxAzimuthAngle, sphericalDelta.theta ) );
                // restrict phi to be between desired limits
                spherical.phi += Math.max( scope.minPolarAngle, Math.min( scope.maxPolarAngle, sphericalDelta.phi ) );
                // apply rotation scale
                spherical.theta = scope.spherical0.theta + (spherical.theta - scope.spherical0.theta) * scope.rotateScale;
                spherical.phi = scope.spherical0.phi + (spherical.phi - scope.spherical0.phi) * scope.rotateScale;
                spherical.makeSafe();
                scope.object.position.setFromSpherical( spherical );
                // rotate offset back to "camera-up-vector-is-up" space
                scope.object.position.applyQuaternion( quatInverse );
                scope.object.lookAt( scope.target );

                // update condition is:
                // min(camera displacement, camera rotation in radians)^2 > EPS
                // using small-angle approximation cos(x/2) = 1 - x^2 / 8

                if ( lastPosition.distanceToSquared( scope.object.position ) > EPS ||
                    8 * ( 1 - lastQuaternion.dot( scope.object.quaternion ) ) > EPS ) {
                    scope.dispatchEvent( changeEvent );
                    lastPosition.copy( scope.object.position );
                    lastQuaternion.copy( scope.object.quaternion );
                    return true;
                }

                return false;
            };

        }();

        this.dispose = function() {
            scope.domElement.removeEventListener( 'contextmenu', onContextMenu, false );
            document.removeEventListener( 'mousemove', onMouseMove, false );
            //scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?
        };

        //
        // internals
        //

        let scope = this;
        let changeEvent = { type: 'change' };
        let STATE = { NONE : - 1, ROTATE : 0 };
        let state = STATE.NONE;
        let EPS = 0.000001;

        // current position in spherical coordinates
        let spherical = new THREE.Spherical();
        let sphericalDelta = new THREE.Spherical();

        let rotateStart = new THREE.Vector2();
        let rotateEnd = new THREE.Vector2();
        let rotateDelta = new THREE.Vector2();

        //
        // event callbacks - update the object state
        //
        function handleMouseMoveRotate( event ) {
            //console.log( 'handleMouseMoveRotate' );
            let element = scope.domElement === document ? scope.domElement.body : scope.domElement;
            rotateStart.set(element.clientWidth / 2, element.clientHeight / 2);
            rotateEnd.set( event.clientX, event.clientY );
            rotateDelta.subVectors( rotateEnd, rotateStart );
            // rotating across whole screen goes 360 degrees around
            sphericalDelta.theta = -2 * Math.PI * rotateDelta.x / element.clientWidth * scope.rotateSpeed;
            // rotating up and down along whole screen attempts to go 360, but limited to 180
            sphericalDelta.phi = -2 * Math.PI * rotateDelta.y / element.clientHeight * scope.rotateSpeed;
            scope.update();
        }

        //
        // event handlers - FSM: listen for events and reset state
        //


        function onMouseMove( event ) {
            if ( scope.enabled === false ) return;

            event.preventDefault();
            if ( state === STATE.ROTATE ) {
                if ( scope.enableRotate === false ) return;
                handleMouseMoveRotate( event );
            }
        }

        function onContextMenu( event ) {
            event.preventDefault();
        }

        //

        scope.domElement.addEventListener( 'contextmenu', onContextMenu, false );
        state = STATE.ROTATE;
        document.addEventListener( 'mousemove', onMouseMove, false );

        // force an update at start
        this.update();

    }

    OrbitControls.prototype = Object.create( THREE.EventDispatcher.prototype );
    OrbitControls.prototype.constructor = OrbitControls;



    return OrbitControls;
};



// WEBPACK FOOTER //
// ./scripts/vendor/three-orbit-control.js